<template>
  <div class="main-wrapper">
    <layout></layout>
    <adminsidebar></adminsidebar>
    <div class="page-wrapper page-settings">
      <div class="content">
        <div class="content-page-header content-page-headersplit mb-0">
          <h5>Comments List</h5>
          <div class="list-btn">
            <ul>
              <li>
                <div class="filter-sorting">
                  <ul>
                    <li>
                      <a href="javascript:void(0);" class="filter-sets"
                        ><img
                          src="@/assets/admin_img/icons/filter1.svg"
                          class="me-2"
                          alt="img"
                        />Filter</a
                      >
                    </li>
                    <li>
                      <span
                        ><img
                          src="@/assets/admin_img/icons/sort.svg"
                          class="me-2"
                          alt="img"
                      /></span>
                      <div class="review-sort">
                        <vue-select
                          :options="Selectcom"
                          id="selectcom"
                          placeholder="A - Z"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-resposnive table-div">
              <div class="table datatable">
                <a-table :columns="columns" :data-source="data">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'User_Name'">
                      <td class="table-namesplit">
                        <a href="javascript:void(0);" class="table-profileimage">
                          <img
                            :src="
                              require(`@/assets/admin_img/customer/${record.User_img}`)
                            "
                            class="me-2"
                            alt="img"
                          />
                        </a>
                        <a href="javascript:void(0);" class="table-name">
                          <span>{{ record.User_Name }}</span>
                          <p>{{ record.User_mail }}</p>
                        </a>
                      </td>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="table-actions d-flex">
                        <a
                          class="delete-table"
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-item"
                        >
                          <img src="@/assets/admin_img/icons/delete.svg" alt="svg" />
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete -->
  <div
    class="modal fade"
    id="delete-item"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Delete Commnts List</h5>
          <button
            type="button"
            class="btn-close close-modal"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="feather feather-x"></i>
          </button>
        </div>
        <b-form @submit.prevent="submitForm">
          <div class="modal-body py-0">
            <div class="del-modal">
              <p>Are you sure want to Delete?</p>
            </div>
          </div>
          <div class="modal-footer pt-0">
            <b-button type="button" variant="secondary" data-bs-dismiss="modal"
              >Cancel</b-button
            >
            <b-button type="submit" variant="primary" data-bs-dismiss="modal"
              >Yes</b-button
            >
          </div>
        </b-form>
      </div>
    </div>
  </div>
  <!-- /Delete -->
</template>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
    sorter: {
      compare: (a, b) => {
        a = a.id.toLowerCase();
        b = b.id.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "User Name",
    dataIndex: "User_Name",
    key: "User_Name",
    sorter: {
      compare: (a, b) => {
        a = a.User_Name.toLowerCase();
        b = b.User_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "Phone",
    sorter: {
      compare: (a, b) => {
        a = a.Phone.toLowerCase();
        b = b.Phone.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Content",
    dataIndex: "Content",
    sorter: {
      compare: (a, b) => {
        a = a.Content.toLowerCase();
        b = b.Content.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Create at",
    dataIndex: "Create_at",
    sorter: {
      compare: (a, b) => {
        a = a.Create_at.toLowerCase();
        b = b.Create_at.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "id",
    sorter: true,
  },
];
const data = [
  {
    id: "1",
    User_img: "user-01.jpg",
    User_Name: "John Smith",
    User_mail: "johnsmith@gmail.com",
    Phone: "+1 843-443-3282",
    Content: "Lorem ipsum dolor sit amet, consectetur elit,",
    Create_at: "28 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "2",
    User_img: "user-07.jpg",
    User_Name: "Johnny",
    User_mail: "johnny@gmail.com",
    Phone: "+1 917-409-0861",
    Content: "Lorem ipsum dolor",
    Create_at: "23 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "3",
    User_img: "user-09.jpg",
    User_Name: "Robert",
    User_mail: "robert@gmail.com",
    Phone: "+1 956-623-2880",
    Content: "Lorem ipsum dolor sit amet, consectetur elit,",
    Create_at: "08 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "4",
    User_img: "user-06.jpg",
    User_Name: "Sharonda",
    User_mail: "sharonda@gmail.com",
    Phone: "02 Sep 2023 16:43PM",
    Content: "Lorem ipsum  amet,  elit,",
    Create_at: "+1 559-741-9672",
    Action: "",
  },
  {
    id: "5",
    User_img: "user-04.jpg",
    User_Name: "Nicholas",
    User_mail: " nicholas@gmail.com",
    Phone: "+1 559-741-9672",
    Content: "Lorem ipsum dolor",
    Create_at: "23 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "6",
    User_img: "user-01.jpg",
    User_Name: "John Smith",
    User_mail: " johnsmith@gmail.com",
    Phone: "+1 843-443-3282",
    Content: "Lorem ipsum dolor sit amet, consectetur elit,",
    Create_at: "28 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "7",
    User_img: "user-07.jpg",
    User_Name: "Johnny",
    User_mail: "johnny@gmail.com",
    Phone: "+1 917-409-0861",
    Content: "Lorem ipsum dolor",
    Create_at: "23 Sep 2023 16:43PM",
    Action: "",
  },
  {
    id: "8",
    User_img: "user-09.jpg",
    User_Name: "Robert",
    User_mail: "robert@gmail.com",
    Phone: "+1 956-623-2880",
    Content: "Lorem ipsum dolor sit amet, consectetur elit,",
    Create_at: "08 Sep 2023 16:43PM",
    Action: "",
  },
];

export default {
  data() {
    return {
      Selectcom: ["A - Z", "Z - A"],
      columns,
      data,
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/admin/blogs-comments");
    },
  },
};
</script>
